import { render, staticRenderFns } from "./QuestionDetail.vue?vue&type=template&id=4dcec4e2&scoped=true&"
import script from "./QuestionDetail.vue?vue&type=script&lang=js&"
export * from "./QuestionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcec4e2",
  null
  
)

export default component.exports